import { render, staticRenderFns } from "./ArticulosPorRubro.vue?vue&type=template&id=692c9738&scoped=true"
import script from "./ArticulosPorRubro.vue?vue&type=script&lang=js"
export * from "./ArticulosPorRubro.vue?vue&type=script&lang=js"
import style0 from "./ArticulosPorRubro.vue?vue&type=style&index=0&id=692c9738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692c9738",
  null
  
)

export default component.exports